import { Search, LogOut, UserCog, ChevronDown } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ProfileEditModal from "./ProfileEditModal";

const Header = ({ onSearch, hideSearch }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [lastLoginTime, setLastLoginTime] = useState("");
  const [username, setUsername] = useState("");
  const [showProfileModal, setShowProfileModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const hideSearchPages = ["/dashboard", "/users", "/marketing"];
  const shouldShowSearch =
    !hideSearchPages.includes(location.pathname) && !hideSearch;

  useEffect(() => {
    const storedTime = localStorage.getItem("lastLoginTime");
    const storedUsername = localStorage.getItem("username") || "Admin Account";
    setUsername(storedUsername);

    if (storedTime) {
      const date = new Date(storedTime);
      setLastLoginTime(
        date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })
      );
    }
  }, []);

  const getSearchPlaceholder = () => {
    switch (location.pathname) {
      case "/products":
        return "Search products...";
      case "/categories":
        return "Search categories...";
      case "/orders":
        return "Search orders...";
      case "/inventory":
        return "Search inventory...";
      case "/coupons":
        return "Search coupons...";
      default:
        return "Search...";
    }
  };

  const handleLogout = () => {
    navigate("/login");
  };

  const handleSearchChange = (e) => {
    if (onSearch) {
      onSearch(e.target.value);
    }
  };

  return (
    <>
      <div
        className={`flex ${
          shouldShowSearch ? "justify-between" : "justify-end"
        } items-center mb-4`}
      >
        {shouldShowSearch && (
          <div className="flex items-center bg-white text-black gap-4 px-4 py-2 rounded-full">
            <Search className="w-4 h-4 text-gray-500" />
            <input
              type="search"
              placeholder={getSearchPlaceholder()}
              className="border-none outline-none bg-white border-gray-200 rounded-md"
              onChange={handleSearchChange}
            />
          </div>
        )}
        <div className="relative">
          <div
            className="flex items-center gap-2 cursor-pointer"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="w-8 h-8 bg-gray-200 font-medium rounded-full"></div>
            <span>{username}</span>
            <ChevronDown className="w-4 h-4" />
          </div>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-10">
              <div className="px-4 py-2 border-b border-gray-200">
                <p className="font-medium">{username}</p>
                <p className="text-sm text-gray-500">
                  Last Login: {lastLoginTime}
                </p>
              </div>
              <div className="py-1">
                {username !== "admin" && (
                  <button
                    className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
                    onClick={() => {
                      setShowProfileModal(true);
                      setShowDropdown(false);
                    }}
                  >
                    <UserCog className="w-4 h-4" />
                    Edit Profile
                  </button>
                )}
                <button
                  className="w-full px-4 py-2 text-left hover:bg-gray-100 flex items-center gap-2"
                  onClick={handleLogout}
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <ProfileEditModal
        isOpen={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        userData={{
          userId: localStorage.getItem("userId"),
        }}
      />
    </>
  );
};

export default Header;
